import { render, staticRenderFns } from "./FormWizardCallFun.vue?vue&type=template&id=252c467a"
import script from "./FormWizardCallFun.vue?vue&type=script&lang=js"
export * from "./FormWizardCallFun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports